import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

export const stylesheet = createStyleSheet({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    borderRadius: '8px',
    padding: '10px 12px',
  },
  containerActive: {
    backgroundColor: COLORS.MENU.ACTIVE_SECONDARY,
  },
  containerHover: {
    backgroundColor: COLORS.MENU.HOVER,
  },
  label: {
    ...TYPOGRAPHY.H2,
    color: COLORS.MENU.DEFAULT,
  },
  labelActive: {
    ...TYPOGRAPHY.H2,
    color: COLORS.MENU.ACTIVE,
  },
});

export default stylesheet;
